import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: '5px',
    width: '90%',
    maxWidth: '550px',
    maxHeight: '500px',
    padding: '40px 20px 20px',
    boxShadow: '0 0 15px 0 rgba(0, 0, 0, .4)',
    border: 'none',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.41)',
    zIndex: 2,
  },
};

export const Container = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between', direction: 'column' })}
  height: 100%;
  position: relative;
`;

export const Header = styled.div`
  ${mixins.flexPosition({ align: 'center', direction: 'column' })}
  margin-bottom: 20px;

  .alert-icon {
    margin-bottom: 20px;
  }
`;

export const Title = styled.h3`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_6,
    styles.fontWeights.SEMIBOLD
  )}
  line-height: 19px;
`;

export const Content = styled.div``;

export const Footer = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  margin-top: 50px;
  width: 100%;
`;

export const ReasonList = styled.ul`
  list-style: none;
  margin: 0 auto;
  max-width: 280px;
`;

export const ReasonItem = styled.li`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Text = styled.p`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  line-height: 18px;
  margin-bottom: 20px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/CancelModal/style.js